import React, { useEffect } from 'react';
import useErrorTrack from '../../hooks/analytics/use-error-track';
import { ErrorType } from '../../types/analytics';
import { COMPONENT_GEO_FENCE } from '../../utils/components-elements';
import { PHILO_HELP_URL } from '../../web-shared/utils/constants';
import { Heading } from '../../web-shared/general/heading';
import { TextLink, TextLinkType } from '../../web-shared/design-system/text-link/text-link';
import styles from './geo-fence.module.sass';

export default function UserGeoFence() {
  const geoFenceHeadingLine = 'Sorry, Philo is only available in the United States... for now.';
  const geoFenceSupport = 'Contact Support for more information.';

  const { handleErrorDisplayedTrack } = useErrorTrack();

  useEffect(() => {
    handleErrorDisplayedTrack({
      message: geoFenceHeadingLine,
      component: COMPONENT_GEO_FENCE,
      errorType: ErrorType.FULLSCREEN,
      canRetry: false,
    });
  }, []);
  return (
    <div className={styles.geoFence}>
      <div className={styles.geoFenceGroup}>
        <Heading level={1} className={styles.geoFenceHeading}>
          {geoFenceHeadingLine}
        </Heading>
        <TextLink
          target="_blank"
          href={PHILO_HELP_URL}
          rel="noopener noreferrer"
          className={styles.geoFenceSupportLink}
          type={TextLinkType.STANDALONE}
        >
          {geoFenceSupport}
        </TextLink>
      </div>
      <div className={styles.geoFenceWorldMapGroup} />
    </div>
  );
}
